// src/plugins/echarts.js
import ECharts from 'vue-echarts'
import { use } from 'echarts/core'
import { CanvasRenderer } from 'echarts/renderers'
import { BarChart, LineChart, PieChart, HeatmapChart, GaugeChart } from 'echarts/charts'
import { GridComponent, TooltipComponent, TitleComponent, LegendComponent, MarkLineComponent, MarkPointComponent, VisualMapComponent } from 'echarts/components'

use([CanvasRenderer, BarChart, LineChart, PieChart, HeatmapChart, GaugeChart, GridComponent, TooltipComponent, TitleComponent, LegendComponent, MarkLineComponent, MarkPointComponent, VisualMapComponent])

export default {
  install(app) {
    app.component('v-chart', ECharts)
  }
}
